const GetResponseApi = {
    /**
     * @param {string} email
     * @returns {boolean}
     */
    setUserId(email) {
        if ('function' === typeof GrTracking) {
            GrTracking('setUserId', email);
        }
    },
};

export {
    GetResponseApi
}
